<figure *ngIf="!showEmptyState; else emptyState" class="highcharts-figure">
  <div class="{{height}} margin-unset" [id]="chartId"></div>
</figure>
<ng-template #emptyState>
  <app-empty-chart [additionalStyle]="height" [circle]="false"></app-empty-chart>
</ng-template>